import { useQuery } from "@tanstack/react-query";
import { apiRequestContractHandlerPropsInput } from "shared/api/apiRequestContractHandler";
import { getSocietyReportsAccessContract } from "shared/api/contracts/society/societyId/reports/access";
import { type SocietyReportAccessParamsInput } from "shared/api/types/society/[societyId]/reports/access";
import { useSocietySession } from "shared/context/SocietySessionContext";

/** Query key prefix; invalidate it after changing report, route or directory access */
export const reportAccessQueryKey = "reportAccess";

type UseReportAccessSummaryProps = {
  /** Narrow to one report, route or directory; omit for the whole society */
  filter?: Omit<SocietyReportAccessParamsInput, "societyId">;
  /** Skip the request, e.g. while an id is still loading */
  enabled?: boolean;
};

/** Report access settings, consumers and problems for the current society */
export const useReportAccessSummary = ({
  filter = {},
  enabled = true,
}: UseReportAccessSummaryProps = {}) => {
  const { societyId } = useSocietySession();
  return useQuery({
    queryKey: [reportAccessQueryKey, societyId, filter],
    queryFn: async () =>
      apiRequestContractHandlerPropsInput({
        contract: getSocietyReportsAccessContract,
        inputs: { params: { societyId, ...filter } },
      }),
    enabled,
    refetchOnMount: true,
  });
};
